// extracted by mini-css-extract-plugin
export default {"description":"NoexperiencesDeleteDeactivate_description__i-CPJ","boldText":"NoexperiencesDeleteDeactivate_boldText__edHyq","footer":"NoexperiencesDeleteDeactivate_footer__OrxAz"};